import { gql } from '@apollo/client'

export const INTERVENTIONS_QUERY = gql`
  query InterventionsDis($trg: String!, $typeequipementId: bigint!) {
    interventions: d4_interventiondemande(
      where: {
        _and: [
          { demande: { copropriete: { trigramme: { _eq: $trg } } } }
          { datecreationdemande: { _gt: "2019-03-22" } }
          { demande: { equipement: { typeequipement_id: { _eq: $typeequipementId } } } }
        ]
      }
      order_by: { datecreationdemande: desc_nulls_last }
    ) {
      id
      datecreationdemande
      fournisseur_id
      fournisseur {
        id
        raisonsociale
        mail1
        telportable
        telfixe
        fournisseur_favori_equipements(
          where: {
            _or: [
              { equipement: { copropriete: { trigramme: { _eq: $trg } } } }
              { equipement: { batiment: { copropriete: { trigramme: { _eq: $trg } } } } }
              { equipement: { typeequipement_id: { _eq: $typeequipementId } } }
            ]
          }
        ) {
          id
          equipement {
            id
            typeequipement_id
          }
        }
      }
    }
  }
`
/**
 * Voir pour faire la query sur le meme equipementId aussi
 */
// export const INTERVENTIONS_ALL_QUERY = gql`
//   query InterventionsAll($typeequipementId: bigint!) {
//     interventions: d4_interventiondemande(
//       where: { demande: { equipement: { typeequipement_id: { _eq: $typeequipementId } } } }
//       order_by: { datecreationdemande: desc_nulls_last }
//       limit: 100
//     ) {
//       id
//       datecreationdemande
//       fournisseur_id
//       demande {
//         id
//         copropriete {
//           trigramme
//         }
//       }
//       fournisseur {
//         id
//         raisonsociale
//         mail1
//         telportable
//         telfixe
//         fournisseur_favori_equipements {
//           id
//           equipement {
//             id
//             typeequipement_id
//           }
//         }
//       }
//     }
//   }
// `

export const INTERVENTIONS_ALL_QUERY = gql`
  query InterventionsAll($typeequipementId: bigint!) {
    interventions: d4_interventiondemande(
      where: { _and: [{ demande: { equipement: { typeequipement_id: { _eq: $typeequipementId } } } }] }
      order_by: { datecreationdemande: desc_nulls_last }
      limit: 500
    ) {
      id
      datecreationdemande
      fournisseur_id
      demande {
        copropriete {
          trigramme
        }
      }
      fournisseur {
        id
        raisonsociale
        mail1
        telportable
        telfixe
        interventions_aggregate(where: { demande: { equipement: { typeequipement_id: { _eq: $typeequipementId } } } }) {
          aggregate {
            count
          }
        }
        fournisseur_favori_equipements {
          id
          equipement {
            id
            typeequipement_id
          }
        }
      }
    }
  }
`

export const INTERVENTIONS_BY_COPRO = gql`
  query InterventionsDis($trg: String!) {
    interventions: d4_interventiondemande(
      where: { demande: { copropriete: { trigramme: { _eq: $trg } } } }
      order_by: { datecreationdemande: desc_nulls_last }
    ) {
      id
      datecreationdemande
      fournisseur_id
      objet
      demande_id
      datepriseencomptefournisseur # prise en compte: null rouge si non vert
      daterappel # Retartito: null rouge ? pas null > now vert < now rouge
      plageinterventionprevue # dateprevu: not null vert
      dateinterventionrealisee
      fournisseur {
        id
        raisonsociale
      }
    }
  }
`
